exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".select-panel[data-v-0c42fba0] .bui-select-panel-left{display:none}.select-panel-search-result[data-v-0c42fba0]{width:calc(100% - 214px);margin-right:16px}\n", ""]);

